<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de paciente">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/exame-imagem/agendamento-retroativo/List'

export default {
    components: { List },
}
</script>